import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStars = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.23212 9.09285C4.1483 9.05932 4.1483 8.94068 4.23212 8.90715L5.66339 8.33464C6.4257 8.02972 7.02972 7.42569 7.33465 6.66339L7.90715 5.23212C7.94068 5.1483 8.05932 5.1483 8.09285 5.23212L8.66536 6.66339C8.97028 7.4257 9.57431 8.02972 10.3366 8.33465L11.7679 8.90715C11.8517 8.94068 11.8517 9.05932 11.7679 9.09285L10.3366 9.66536C9.57431 9.97028 8.97028 10.5743 8.66536 11.3366L8.09285 12.7679C8.05932 12.8517 7.94068 12.8517 7.90715 12.7679L7.33465 11.3366C7.02972 10.5743 6.4257 9.97028 5.66339 9.66536L4.23212 9.09285Z",
			fill: "#535353",
			stroke: "#535353",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.51419 2.61L9.00024 3L9.5142 3.38984C9.5505 3.41737 9.58287 3.44974 9.61041 3.48604L10.0002 4L10.3899 3.48603C10.4175 3.44967 10.4499 3.41725 10.4863 3.38968L11.0002 3L10.4863 2.61016C10.45 2.58263 10.4176 2.55026 10.3901 2.51396L10.0002 2L9.61025 2.51394C9.58275 2.55018 9.55043 2.5825 9.51419 2.61Z",
			fill: "#535353",
			stroke: "#535353",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 3L2.81623 3.55132C2.61716 4.14853 2.14853 4.61716 1.55132 4.81623L1 5L1.55132 5.18377C2.14853 5.38284 2.61716 5.85147 2.81623 6.44868L3 7L3.18377 6.44868C3.38284 5.85147 3.85147 5.38284 4.44868 5.18377L5 5L4.44868 4.81623C3.85147 4.61716 3.38284 4.14853 3.18377 3.55132L3 3Z",
			fill: "#535353",
			stroke: "#535353",
			strokeLinejoin: "round"
		})
	]
});
export default SvgStars;
